import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

import ClubSession from "state/school_money/entities/ClubBooking/ClubSession";

export const ClubBooking = new Immutable.Record({
  ...studentLinked.defaultProperties,
  remotePaymentID: undefined,
  remoteInstallmentID: undefined,
  description: undefined,
  startDate: undefined,
  endDate: undefined,
  lastModifiedDate: undefined,
  paidAmount: undefined,
  outstandingAmount: undefined,
  isReservationsEnabled: undefined,
  requiresParentalConsent: undefined,
  isParentalConsentGiven: undefined,
  hasLimitedPlaces: undefined,
  dailyPlacesLimit: undefined,
  placesLimitReached: undefined,
  sessions: undefined,
  bookedSessionIDs: undefined,
  selectedSessionIDs: undefined,
  dates: undefined,
  holidays: undefined,
  expired: undefined,
  forceSessionBooking: undefined
}, "ClubBooking");

function buildClubBookingFromAppserver(rawPayment) {
  const rawClubBooking = rawPayment.payload;
  // TODO: fix on server end (hopefully?)
  rawPayment.student_fk = rawClubBooking.student_fk;
  const props = {
    ...studentLinked.appserverAdapter(rawPayment),
    remotePaymentID: rawClubBooking.payment_fk,
    remoteInstallmentID: rawClubBooking.installment_fk,
    description: rawClubBooking.description,
    startDate: rawClubBooking.club_start_date,
    endDate: rawClubBooking.club_end_date,
    lastModifiedDate: rawClubBooking.last_modified_date_time,
    paidAmount: floatToMoney(rawClubBooking.previous_amount),
    outstandingAmount: floatToMoney(rawClubBooking.outstanding),
    isReservationsEnabled: rawClubBooking.enable_reservations,
    requiresParentalConsent: rawClubBooking.requires_parental_consent,
    isParentalConsentGiven: rawClubBooking.consent_date !== "",
    hasLimitedPlaces: rawClubBooking.daily_places_limit !== -1,
    placesLimitReached: buildPlacesLimitReachedFromAppserver(rawClubBooking),
    sessions: buildSessionsFromAppserver(rawClubBooking),
    bookedSessionIDs: buildBookedSessionIDsFromAppserver(rawClubBooking),
    dates: buildDatesFromAppserver(rawClubBooking),
    holidays: buildHolidaysFromAppserver(rawClubBooking),
    expired: buildExpiredFromAppserver(rawClubBooking),
    dailyPlacesLimit: rawClubBooking.daily_places_limit,
    forceSessionBooking: rawClubBooking.force_session_booking
  }
  props.selectedSessionIDs = props.bookedSessionIDs;
  props.placesTotal = props.hasLimitedPlaces ? rawClubBooking.daily_places_limit : null;
  return ClubBooking(props);
}

function buildSessionsFromAppserver(rawClubBooking) {
  const sessionList = new Immutable.List( Object.values(rawClubBooking.club_sessions) )
    .filter(rawClubSession => rawClubSession.price !== -1)
    .map(ClubSession.fromAppserver);
  return new Immutable.Map( sessionList.map(session => [ session.id, session ]) );
}

function buildBookedSessionIDsFromAppserver(rawClubBooking) {
  return getBookingsFromAppserver(rawClubBooking).map(rawBookedSession => {
    if (rawBookedSession.status === "Y") {
      return rawBookedSession.session_booked.id;
    }
    return null;
  });
}

function buildPlacesLimitReachedFromAppserver(rawClubBooking) {
  return getBookingsFromAppserver(rawClubBooking).map(rawBookedSession => {
    return rawBookedSession.places_available <= 0;
  });
}

function buildDatesFromAppserver(rawClubBooking) {
  return getBookingsFromAppserver(rawClubBooking)
    .map(({ club_date }) => club_date);
}

function buildHolidaysFromAppserver(rawClubBooking) {
  return getBookingsFromAppserver(rawClubBooking).map(rawBookedSession => {
    return rawBookedSession.status === "HOLIDAY";
  });
}

function buildExpiredFromAppserver(rawClubBooking) {
  return getBookingsFromAppserver(rawClubBooking)
    .map(rawBookedSession => rawBookedSession.expired);
}

function getBookingsFromAppserver(rawClubBooking) {
  return new Immutable.List([
    rawClubBooking.monday_booking,
    rawClubBooking.tuesday_booking,
    rawClubBooking.wednesday_booking,
    rawClubBooking.thursday_booking,
    rawClubBooking.friday_booking,
  ]);
}

export { ClubSession };
ClubBooking.ClubSession = ClubSession;
ClubBooking.fromAppserver = buildClubBookingFromAppserver;
export default ClubBooking;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/ClubBooking/index.js